const ptPT = {
  locale: 'pt-PT',
  stages: {
    contract: { title: 'Revisão do contrato + sinal de 50%', owner: 'Cliente + GuideSofia' },
    kickoff: { title: 'Reunião de kickoff', owner: 'Cliente + GuideSofia' },
    routeMaterials: { title: 'Rota / paragens + materiais', owner: 'Cliente' },
    draft: { title: 'Primeira versão do script', owner: 'GuideSofia' },
    midwork: { title: 'Ponto de situação intermédio', owner: 'Cliente + GuideSofia' },
    review: { title: 'Revisão do cliente', owner: 'Cliente' },
    translations: { title: 'Traduções + locuções', owner: 'GuideSofia' },
    qa: { title: 'controle de qualidade geral (humano)', owner: 'GuideSofia' },
    launch: { title: 'Comunicação de lançamento', owner: 'Cliente + GuideSofia' }
  },
  materials: {
    institution: 'Nome da instituição / projeto',
    contact: 'Pessoa principal de contacto',
    objective: 'Objetivo do projeto',
    texts: 'Textos / docs / PDFs',
    media: 'Fotografias / áudio / media',
    venue: 'Contexto do espaço / projeto',
    route: 'Lista de paragens / indicação de rota',
    gps: 'Pontos GPS',
    brand: 'Diretrizes de marca / logótipo',
    accessibility: 'Necessidades de acessibilidade',
    launchDate: 'Data de lançamento ou calendário ideal'
  },
  payments: {
    contractStage: 'Revisão do contrato',
    paymentStage: 'Sinal de 50%',
    contractPaymentStage: 'Revisão do contrato + sinal de 50%',
    contractReviewed: 'Contrato revisto',
    contractSigned: 'Contrato assinado',
    depositPaid: 'Sinal de 50% pago na assinatura',
    finalPaid: 'Pagamento final de 50% na entrega do guia'
  },
  statuses: {
    todo: 'Por fazer',
    active: 'Em curso',
    blocked: 'A aguardar ação',
    done: 'Concluído'
  },
  projectTypes: {
    museum: 'Guia de museu',
    municipality: 'Município / destino',
    temporary: 'Exposição temporária',
    pilot: 'Projeto-piloto',
    virtual: 'Visita virtual / 360'
  },
  tabs: {
    timeline: 'Calendário',
    production: 'Produção',
    'project-details': 'Detalhes do projeto',
    materials: 'Materiais',
    review: 'Revisão',
    launch: 'Lançamento',
    'add-ons': 'Extras opcionais',
    'launch-assets': 'Materiais de lançamento',
    'qr-codes': 'QR Codes',
    'media-press': 'Media Package',
    'launch-plan': 'Plano de lançamento',
    'launch-training': 'Formação',
    documents: 'Documentos',
    payments: 'Pagamentos',
    scope: 'Âmbito e alterações',
    contact: 'Contacto',
    roles: 'Responsabilidades',
    faq: 'FAQ',
    languages: 'Idiomas'
  },
  launchItems: {
    contentApproved: 'Conteúdo aprovado',
    translationsApproved: 'Traduções aprovadas',
    audioChecked: 'Áudio verificado',
    qrTested: 'QR codes testados',
    qrPlaced: 'QR codes físicos colocados',
    teamInformed: 'Equipa de receção / atendimento informada',
    websiteReady: 'Website ou publicação social preparada',
    analyticsActive: 'Analytics ativados',
    launchConfirmed: 'Data de lançamento confirmada'
  },
  launchAssets: {
    qrCodeLinks: 'Links dos QR codes',
    promoMaterialsLinks: 'Links dos materiais promocionais'
  },
  mediaPress: {
    mediaKitUrl: 'Link do media kit',
    pressReleaseUrl: 'Link do comunicado de imprensa',
    pressCoverageLinks: 'Links de cobertura de imprensa'
  },
  reviewItems: {
    clientGuideText: 'Texto do guia revisto',
    qaTexts: 'Controlo de qualidade de textos (Humano)',
    qaQrCodes: 'Controlo de qualidade de QR codes (Humano)',
    qaAudios: 'Controlo de qualidade de áudios (Humano)'
  },
  qrPlacements: {
    reception: 'Receção / bilheteira',
    routeStart: 'Início da rota',
    stops: 'Cada sala, paragem ou área de objeto',
    printed: 'Mapas impressos / brochuras',
    website: 'Website',
    social: 'Redes sociais / newsletter'
  },
  addOns: {
    'venue-pages': {
      label: 'Páginas do espaço',
      description: 'Páginas dedicadas ao espaço ou à exposição, ligadas ao audioguia.'
    },
    'qr-rollout': {
      label: 'Implementação de QR',
      description: 'Apoio adicional na implementação, planeamento e colocação dos QR codes.'
    },
    translations: {
      label: 'Traduções + locuções',
      description: 'Traduções e locuções adicionais para além do âmbito base do projeto.'
    },
    'virtual-360': {
      label: 'Visita virtual 360',
      description: 'Uma experiência virtual em 360 graus para visitas remotas ou híbridas.'
    },
    'augmented-reality': {
      label: 'Realidade aumentada',
      description: 'Momentos de AR que acrescentam camadas digitais à experiência do visitante.'
    },
    gamification: {
      label: 'Gamificação',
      description: 'Questionários, desafios ou interações lúdicas para os visitantes.'
    },
    'sign-language-pt': {
      label: 'Língua gestual portuguesa',
      description: 'Suporte de acessibilidade com conteúdo em língua gestual portuguesa.'
    },
    'collection-catalog': {
      label: 'Catálogo de coleção',
      description: 'Um catálogo digital para a coleção ou para os destaques da exposição.'
    },
    surveys: {
      label: 'Inquéritos',
      description: 'Inquéritos ao visitante ou formulários de feedback ligados ao projeto.'
    },
    'advanced-content': {
      label: 'Conteúdo avançado',
      description: 'Narrativas mais ricas, funcionalidades especiais ou módulos de conteúdo alargados.'
    }
  },
  guideLanguages: {
    'pt-PT': 'Português (PT-PT)',
    en: 'Inglês',
    es: 'Espanhol',
    fr: 'Francês',
    de: 'Alemão',
    it: 'Italiano',
    nl: 'Neerlandês',
    ru: 'Russo',
    ar: 'Árabe',
    zh: 'Chinês',
    ja: 'Japonês'
  },
  guideSofiaResponsibilities: [
    'Estruturar o guia digital',
    'Criar ou adaptar os guiões',
    'Preparar traduções quando incluídas',
    'Gerar QR codes e links do guia',
    'Publicar a experiência do visitante',
    'Disponibilizar analytics e suporte técnico'
  ],
  clientResponsibilities: [
    'Partilhar materiais oficiais',
    'Validar rigor histórico e factual',
    'Aprovar o conteúdo final',
    'Colocar os QR codes no espaço',
    'Promover o guia junto dos visitantes',
    'Informar equipas de receção ou atendimento'
  ],
  faq: [
    {
      question: 'Quanto tempo demora a implementação?',
      answer: 'Depende do número de paragens, línguas, ciclos de revisão e da complexidade do conteúdo. O calendário acima mostra a estimativa atual.'
    },
    {
      question: 'Precisamos de ter todo o conteúdo pronto?',
      answer: 'Não. A GuideSofia pode trabalhar com materiais existentes ou ajudar a adaptar conteúdos para uma narrativa orientada para o visitante.'
    },
    {
      question: 'Quem valida o rigor histórico?',
      answer: 'O cliente valida o rigor factual e institucional antes de o guia ser aprovado para produção e lançamento.'
    },
    {
      question: 'Podemos atualizar o guia mais tarde?',
      answer: 'Sim, podem ser planeadas atualizações depois do lançamento, consoante o pacote e as necessidades operacionais.'
    },
    {
      question: 'Podemos ver dados de utilização?',
      answer: 'Sim. Os analytics podem mostrar o volume de acessos, as línguas utilizadas, as paragens mais vistas e oportunidades de melhoria.'
    }
  ],
  copy: {
    loading: 'A carregar página de onboarding...',
    unavailable: 'Esta página de onboarding não está disponível.',
    passwordPrompt: 'Introduza a palavra-passe fornecida pela GuideSofia.',
    incorrectPassword: 'Palavra-passe incorreta.',
    viewOnboarding: 'Ver onboarding',
    onboardingLabel: 'Onboarding GuideSofia',
    pageSummary: 'itens pedidos',
    received: 'recebidos',
    noActivePhase: 'Sem fase ativa',
    hubTitle: 'Client Onboarding Hub',
    hubIntro: 'O que acontece agora, o que precisamos de si e como tornar este lançamento simples?',
    hubDescription: 'Esta página mantém o projeto claro depois da aprovação: calendário, pedidos de materiais, estado da revisão, prontidão para lançamento, rollout de QR e responsabilidades.',
    openHubButton: 'Abrir hub do projeto',
    requestedItems: 'Itens pedidos',
    launchReady: 'Pronto para lançar',
    guideQrTitle: 'Código QR do guia',
    guideQrHelp: 'A imagem QR que o cliente vai digitalizar para abrir o guia diretamente.',
    uploadGuideQr: 'Carregar imagem QR',
    openGuideQr: 'Abrir imagem QR',
    guideQrReady: 'Imagem QR carregada',
    guideQrMissing: 'Ainda não foi carregada nenhuma imagem QR.',
    launchDates: 'Datas de lançamento',
    estimatedLaunchDate: 'Data estimada de lançamento',
    agreedLaunchDate: 'Data acordada de lançamento',
    welcomeTitle: 'Bem-vindo à GuideSofia',
    welcomeBody: 'Estamos entusiasmados por ajudar a criar uma experiência multilingue, acessível e orientada por dados para o seu museu, município, rota ou destino.',
    welcomeSupporting: 'Nesta página encontra as etapas do projeto, materiais necessários, calendário, responsabilidades e links úteis.',
    buildTitle: 'O que vamos construir em conjunto',
    buildBody: 'A GuideSofia ajuda os visitantes a explorar espaços culturais no próprio telemóvel, com QR codes, narrativa áudio, mapas, conteúdos multilingues, acessibilidade e analytics.',
    buildListTitle: 'O seu projeto pode incluir',
    buildList: [
      'Paragens de audioguia',
      'QR codes',
      'Mapa interativo',
      'Conteúdo multilingue',
      'Adaptações de acessibilidade',
      'Analytics de visitantes'
    ],
    accessibilityTitle: 'Acessibilidade e inclusão',
    accessibilityBody: 'A GuideSofia foi pensada para tornar as experiências culturais mais acessíveis, incluindo para visitantes cegos e com baixa visão, pessoas surdas, públicos internacionais e quem prefere visitas autónomas.',
    accessibilityPoints: [
      'Acesso multilingue',
      'Experiência centrada em áudio',
      'Suporte em texto',
      'Possibilidade de integração de vídeos em Língua Gestual',
      'Preparada para utilização por pessoas cegas e compatível com leitores de ecrã',
      'Modelo inclusivo BYOD'
    ],
    analyticsTitle: 'Analytics e impacto',
    analyticsBody: 'Depois do lançamento, a GuideSofia pode ajudar a perceber como os visitantes usam a experiência e onde a melhorar.',
    analyticsButton: 'Detalhes de analytics',
    languageLabel: 'Idioma',
    projectTimeline: 'Calendário do projeto',
    projectTypeNotSet: 'Tipo de projeto não definido',
    noStages: 'Sem etapas',
    workingDays: 'dias úteis',
    complete: 'concluído',
    to: 'a',
    guideSofiaLegend: 'GuideSofia',
    clientLegend: 'Cliente',
    sharedLegend: 'Partilhado',
    weekendLegend: 'Fim de semana',
    today: 'Hoje',
    ganttChart: 'Gráfico de Gantt',
    whatWeNeed: 'O que precisamos',
    pending: 'Pendente',
    noMaterialRequests: 'Ainda não foram selecionados pedidos de materiais.',
    uploadDrive: 'Carregar ficheiros para o Drive da GuideSofia',
    contractPayment: 'Contrato + pagamento',
    contractOnly: 'Contrato',
    paymentOnly: 'Pagamento',
    contractPaymentHelp: '50% na assinatura, 50% na entrega do guia.',
    contractOnlyHelp: 'Revisão e assinatura do contrato.',
    paymentOnlyHelp: 'Estado do pagamento deste projeto.',
    reviewDocument: 'Documento de revisão',
    reviewDocumentHelp: 'Utilize este documento para rever o texto do guia e deixar comentários. Pode sugerir alterações ao texto, acrescentar ou remover pontos, mudar a ordem e deixar comentários no Google Docs para depois fazermos a revisão.',
    openReviewDoc: 'Abrir documento de revisão',
    reviewDocMissing: 'O documento de revisão ainda não foi definido.',
    reviewChecklist: 'Checklist de revisão',
    clientReview: 'Revisão do cliente',
    guidesofiaQa: 'Controlo de qualidade (Humano)',
    guidesofiaQaDescription: 'A GuideSofia verifica o conteúdo, os QR codes e os áudios antes do lançamento.',
    reviewTextReviewedLabel: 'Texto revisto pelo cliente: aprovado para produção',
    reviewTextReviewedPendingStatus: 'A aguardar confirmação do cliente',
    reviewTextReviewedApprovedStatus: 'Aprovado para produção',
    reviewTextReviewedConfirmTitle: 'Confirmar revisão',
    reviewTextReviewedConfirmBody: 'Confirme que reviu o texto e que o considera adequado para produção. A equipa da GuideSofia será notificada.',
    reviewTextReviewedConfirmAction: 'Confirmar',
    reviewTextReviewedCancelAction: 'Cancelar',
    launchChecklist: 'Checklist de lançamento',
    launchChecklistHelp: 'Itens que devem estar prontos antes de entrar em funcionamento.',
    qrImplementation: 'Implementação de QR',
    qrImplementationHelp: 'Posicionamentos selecionados para este lançamento.',
    noQrPlacements: 'Ainda não foram selecionados posicionamentos QR.',
    qrCallToAction: 'Use frases curtas e orientadas para a ação, que expliquem logo ao visitante o benefício imediato, como "Digitalize para iniciar o audioguia", "Abra a rota no seu idioma" ou "Descubra esta paragem em menos de um minuto".',
    launchAssetsTitle: 'Materiais de lançamento',
    launchAssetsHelp: 'Links para QR codes e materiais promocionais.',
    noLinksAdded: 'Sem links adicionados.',
    launchAssetsSummary: 'Resumo',
    launchAssetsEmpty: 'Os links de lançamento aparecerão aqui quando forem adicionados.',
    mediaPressTitle: 'Media / imprensa',
    mediaPressHelp: 'Aceda ao media kit, comunicado de imprensa e cobertura de lançamento num só local.',
    mediaPressEmpty: 'Os links de media e imprensa aparecerão aqui quando forem adicionados.',
    mediaPressNotesTitle: 'Notas de mensagem',
    mediaPressNotesEmpty: 'Ainda não foram adicionadas notas de mensagem.',
    paymentsTitle: 'Pagamentos',
    paymentsHelp: 'Dados bancários e estado do pagamento deste projeto.',
    paymentStatus: 'Estado do pagamento',
    paymentComplete: 'Pagamento completo',
    paymentCompleteYes: 'Sim, o pagamento está completo',
    paymentCompleteNo: 'Não, o pagamento ainda está em aberto',
    paymentNotes: 'Notas',
    documentsTitle: 'Documentos',
    documentsHelp: 'Documentos partilhados deste projeto, como contratos e ficheiros de apoio.',
    openDocumentsLink: 'Abrir pasta de documentos',
    documentsMissing: 'O link de documentos ainda não foi definido.',
    contactTitle: 'Contacto do projeto GuideSofia',
    contactHelp: 'O seu contacto principal para questões, aprovações e coordenação do dia a dia.',
    clientContactTitle: 'Contacto do projeto do cliente',
    clientContactHelp: 'Pessoa de contacto principal do lado do cliente para aprovações e coordenação.',
    projectManager: 'Gestor de projeto',
    contactName: 'Nome do contacto',
    email: 'Email',
    whatsapp: 'Telefone / WhatsApp',
    notSetYet: 'Ainda não definido',
    meetingTitle: 'Marcar reunião',
    meetingHelp: 'Precisa de ajuda com algo? Marque uma chamada com a equipa GuideSofia.',
    openBookingLink: 'Abrir link de marcação',
    bookingMissing: 'O link de marcação ainda não foi definido.',
    gsResponsibilities: 'Responsabilidades GuideSofia',
    clientResponsibilities: 'Responsabilidades do cliente',
    faqTitle: 'FAQ',
    addOnsTitle: 'Extras opcionais',
    addOnsHelp: 'Serviços extra que pode escolher para expandir o projeto.',
    addOnsEmpty: 'Ainda não há extras opcionais destacados para este projeto.',
    addOnsNextTitle: 'Tem interesse em algum destes extras?',
    addOnsNextHelp: 'Se algum destes extras fizer sentido, diga-nos e podemos incluí-lo na próxima fase do projeto.',
    addOnsNextBody: 'Pode indicar esse interesse na próxima revisão ou marcar uma reunião com a equipa GuideSofia para falar sobre âmbito, prazos e preço.',
    additionalContactLabel: 'Contacto adicional',
    languagesTitle: 'Idiomas',
    languagesHelp: 'Veja que idiomas do guia estão selecionados e quais já estão prontos.',
    languagesSummaryTitle: 'Todos os idiomas',
    languagesSummaryHelp: 'Idiomas selecionados e o respetivo estado.',
    selected: 'Selecionado',
    ready: 'Pronto',
    inProgress: 'Em progresso',
    notSelected: 'Não selecionado',
    noLanguagesSelected: 'Ainda não há idiomas do guia selecionados.',
    baseLanguage: 'Idioma base',
    additionalLanguage: 'Idioma adicional'
  }
};

export default ptPT;
